<template>
    <div>
        <br/>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto form-inline">
                <form class="my-2 my-lg-0">
                    <button @click="showMachineProduct(null)" type="button" class="btn btn-warning">
                        <icon name="plus"></icon>
                        เพิ่มเครื่องขึ้นรูป
                    </button>
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ชื่อเครื่อง</th>
                    <th scope="col">รายละเอียดเครื่อง</th>
                    <th scope="col">แก้ไข</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in productMachineList">
                    <td>
                        {{data.name}}
                    </td>
                    <td>
                        <template v-if="data.description">
                            {{data.description}}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <a @click="showMachineProduct(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <!---pagination--->
        <div v-if="productMachineList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getMachinePage">
            </vue-pagination>
        </div>
        <br/>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import VuePagination from "../../Pagination";

    export default {
        components: {VuePagination},
        name: "machine-product-list",
        created(){
            this.$store.dispatch("MachineProduct/getMachine")
        },
        computed:{
            ...mapState({
                productMachineList : state=>{
                    return state.MachineProduct.machine_product_list
                },
                dataPaginate:state=>{
                    return state.MachineProduct.dataPaginate;
                },
            })
        },
        methods:{
            showMachineProduct(id){
                if(id){
                    this.$store.dispatch('MachineProduct/showMachineById',id);
                }
                else{
                    this.$store.dispatch("MachineProduct/clearForm");
                }
                this.$router.push("/machine-product-form");
            },
            getMachinePage(){
                const page = this.dataPaginate.current_page;
                this.$store.dispatch('MachineProduct/getMachine',page)
            }
        }
    }
</script>

<style scoped>

</style>